<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="TOC">
<a id="page09"></a>
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
<div class="contentsEntry" id="coverpage">
<p class="contentsEntryName"><a href="#/001coverpage">Cover</a></p>
</div>
<div class="contentsEntry" id="titlepage">
<p class="contentsEntryName"><a href="#/002titlepage">Title Page</a></p>
</div>
<div class="contentsEntry" id="dedicationpage">
<p class="contentsEntryName"><a href="#/003dedicationpage">Dedication</a></p>
</div>
<div class="contentsEntry" id="frontmatterpage_01">
<p class="contentsEntryName"><a href="#/005frontmatterpage01#frontmatterpage01">Introduction</a></p>
</div>
<p class="spaceBreak"> </p>
<div class="contentsEntry" id="part_01">
<p class="contentsEntryNumber1"><a href="#/006part01#part01">One</a></p>
<p class="contentsEntryName1">The World That Johnson Knew</p></div>
<div class="contentsEntry" id="chapter_01">
<p class="contentsEntryName"><a href="#/007chapter01#chapter01">1</a> What Is Blues?</p></div>
<div class="contentsEntry" id="chapter_02">
<p class="contentsEntryName"><a href="#/008chapter02#chapter02">2</a> Race Records: Blues Queens, Crooners, Street Singers, and Hokum</p></div>
<div class="contentsEntry" id="chapter_03">
<p class="contentsEntryName"><a href="#/009chapter03#chapter03">3</a> What the Records Missed</p></div>
<div class="contentsEntry" id="chapter_04">
<p class="contentsEntryName"><a href="#/010chapter04#chapter04">4</a> Hollers, Moans, and “Deep Blues”</p></div>
<div class="contentsEntry" id="chapter_05">
<p class="contentsEntryName"><a href="#/011chapter05#chapter05">5</a> The Mississippi Delta: Life and Listening</p></div>
<div class="contentsEntry" id="part_02">
<p class="contentsEntryNumber1"><a href="#/012part02#part02">Two</a></p>
<p class="contentsEntryName1">Robert Johnson</p></div>
<div class="contentsEntry" id="chapter_06">
<p class="contentsEntryName"><a href="#/013chapter06#chapter06">6</a> A Life Remembered</p></div>
<div class="contentsEntry" id="chapter_07">
<p class="contentsEntryName"><a href="#/014chapter07#chapter07">7</a> The Music</p></div>
<div class="contentsEntry" id="chapter_08">
<p class="contentsEntryName"><a href="#/015chapter08#chapter08">8</a> First Sessions, Part One: Going For Some Hits</p></div>
<div class="contentsEntry" id="chapter_09">
<p class="contentsEntryName"><a href="#/016chapter09#chapter09">9</a> First Sessions, Part Two: Reaching Back</p></div>
<div class="contentsEntry" id="chapter_10">
<p class="contentsEntryName"><a href="#/017chapter10#chapter10">10</a> Second Sessions: The Professional</p></div>
<div class="contentsEntry" id="chapter_11">
<p class="contentsEntryName"><a href="#/018chapter11#chapter11">11</a> The Legacy</p></div>
<a id="page10"></a>
<div class="contentsEntry" id="part_03">
<p class="contentsEntryNumber1"><a href="#/019part03#part03">Three</a></p>
<p class="contentsEntryName1">The Blues Roll On</p></div>
<div class="contentsEntry" id="chapter_12">
<p class="contentsEntryName"><a href="#/020chapter12#chapter12">12</a> Jump Shouters, Smooth Trios, and Down-Home Soul</p></div>
<div class="contentsEntry" id="chapter_13">
<p class="contentsEntryName"><a href="#/021chapter13#chapter13">13</a> The Blues Cult: Primitive Folk Art and the Roots of Rock</p></div>
<div class="contentsEntry" id="chapter_14">
<p class="contentsEntryName"><a href="#/022chapter14#chapter14">14</a> Farther On Up the Road: Wherefore and Whither the Blues</p></div>
<p class="spaceBreak"> </p>
<div class="contentsEntry1" id="backmatterpage_01">
<p class="contentsEntryName"><a href="#/023backmatterpage01#backmatterpage01">Afterthought:</a> So What about the Devil?</p></div>
<div class="contentsEntry1" id="backmatterpage_02">
<p class="contentsEntryName"><a href="#/024backmatterpage02#backmatterpage02">Appendix</a></p></div>
<div class="contentsEntry1" id="backmatterpage_03">
<p class="contentsEntryName"><a href="#/025backmatterpage03#backmatterpage03">Notes</a></p></div>
<div class="contentsEntry1" id="backmatterpage_04">
<p class="contentsEntryName"><a href="#/026backmatterpage04#backmatterpage04">Bibliography</a></p></div>
<div class="contentsEntry1" id="index_page">
<p class="contentsEntryName"><a href="#/027indexpage#indexpage">Searchable Terms</a></p></div>
<div class="contentsEntry1" id="acknowledgments_page">
<p class="contentsEntryName"><a href="#/028acknowledgmentspage#acknowledgmentspage">Acknowledgments</a></p></div>
<div class="contentsEntry1" id="abouttheauthor_page">
<p class="contentsEntryName"><a href="#/029abouttheauthorpage#abouttheauthorpage">About the Author</a></p></div>
<div class="contentsEntry1" id="review_page">
<p class="contentsEntryName"><a href="#/030reviewpage#reviewpage">Praise</a></p></div>
<div class="contentsEntry1" id="copyright_page">
<p class="contentsEntryName"><a href="#/031copyrightpage#copyrightpage">Copyright</a></p></div>
<div class="contentsEntry1" id="aboutpublisher_page">
<p class="contentsEntryName"><a href="#/032aboutpublisherpage#aboutpublisherpage">About the Publisher</a></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004-TOC.vue?050a1d55